import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { useQuery } from 'react-query';
import { getAllProducts } from '../../api/apis';
import { IProduct } from '../../lib/interfaces/Product';
import ProductsCard from './ProductCard';
import Footer from '../Home/Footer';
import './ProductLayout.scss';
import '../Home/Home.scss';

const ProductsLayout: FC = () => {
	const { t } = useTranslation();
	const { data } = useQuery<IProduct[], Error>(['products'], () =>
		getAllProducts(),
	);

	return (
		<>
			<div className="ProductLayout">
				<div className="ProductLayout__wrapper">
					{/* <h1 className="page-title">{t('services')}</h1> */}
					<div className="ProductLayout__header">
						<Typography variant="h3" component="h1" sx={{ fontWeight: 600 }}>
							{t('services')}
						</Typography>
						<Typography variant="body1" component="p">
							{t('servicesSlogan')}
						</Typography>
					</div>
					<div className="ProductLayout__cards-wrapper">
						{data?.map((product) => (
							<div key={product.slug} className="ProductLayout__card-item">
								<ProductsCard product={product} />
							</div>
						))}
					</div>
				</div>
			</div>
			<div className="home-wrapper">
				<Footer />
			</div>
		</>
	);
};

export default ProductsLayout;
